import { useTranslation } from '@doccareplus/shared/lib';
import { BottomSheet, Button } from '@doccareplus/ui';
import { PatientRegisterFields } from '../shared/PatientRegisterFields';
import { useRegisterPatientForm } from '../shared/useRegisterPatientForm';

/**
 * RegisterPatientSheet — mobile bottom-sheet variant of patient registration.
 * Shares the field body and form hook with the desktop modal.
 */
export function RegisterPatientSheet({
  onClose,
  onRegistered,
}: {
  onClose: () => void;
  onRegistered?: (patientId: string) => void;
}) {
  const { t } = useTranslation('patients');
  const form = useRegisterPatientForm();

  const handleSubmit = async () => {
    const id = await form.submit();
    if (id) {
      onRegistered?.(id);
      onClose();
    }
  };

  return (
    <BottomSheet title={t('register.title')} description={t('register.description')} onClose={onClose}>
      <PatientRegisterFields
        fields={form.fields}
        setField={form.setField}
        error={form.error}
        duplicateMatches={form.duplicateMatches}
        duplicateReason={form.duplicateReason}
        setDuplicateReason={form.setDuplicateReason}
        onSubmit={handleSubmit}
      />
      <Button
        type="button"
        variant="primary"
        fullWidth
        className="mt-4"
        onClick={handleSubmit}
        isLoading={form.isSubmitting}
      >
        {form.requiresDuplicateReview ? t('register.duplicates.continue') : t('register.submit')}
      </Button>
    </BottomSheet>
  );
}
